export default "__VITE_PUBLIC_ASSET__e06a7852__"